import Vue from "vue";

export default {
  state() {
    return {
      products: [],
      takeaway: [],
      cartItem: {},

      productsCartDialog: false,
      emptyCartDialog: false,
      editCartItemPriceDialog: false,
    };
  },

  getters: {
    productsCartInfo(state) {
      return {
        numberOfProducts: state.products.length.toString(),
        sum: state.products.reduce(function(accumulator, product) {
          return accumulator + Number(product.price) * Number(product.quantity);
        }, 0),
      };
    },
  },

  mutations: {
    setProductsCartDialog(state, status = null) {
      state.productsCartDialog = status;
    },

    setEmptyCartDialog(state, status = null) {
      state.emptyCartDialog = status;
    },

    refreshCartItem(state, payload) {
      state.cartItem = {};
      state.cartItem = Object.assign({}, state.cartItem, payload);
    },

    changeCartItemPrice(state, payload) {
      var items = state.products.filter((product) => {
        if (product.id === payload.id) return product;
      });
      Vue.set(items[0], "price", payload.price);
    },

    setEditCartItemPriceDialog(state, status = null) {
      state.editCartItemPriceDialog = status;
    },

    resetCartItemName(state, payload) {
      var items = state.products.filter((product) => {
        if (product.id === payload.itemId) return product;
      });
      const item = items[0];
      var newName;

      if (payload.takeaway) {
        if (item.name.indexOf(" - [Takeaway]") === -1) {
          newName = item.name + " - [Takeaway]";
          Vue.set(item, "name", newName);
        } else return;
      } else {
        // newName = item.name.replace(" - [Takeaway]", "");
        // Vue.set(item, "name", newName);
      }
    },

    addToProductsCart(state, payload) {
      var payloadClone = JSON.parse(JSON.stringify(payload));
      var newCartProducts = JSON.parse(JSON.stringify(payload));

      for (var product of payloadClone) {
        var duplicate = state.products.filter(
          (cartProduct) => cartProduct.id === product.id
        );
        if (duplicate.length) {
          Vue.set(duplicate[0], "quantity", duplicate[0].quantity + 1);

          newCartProducts
            .filter((product) => product.id === duplicate[0].id)
            .map((product) =>
              newCartProducts.splice(newCartProducts.indexOf(product), 1)
            );
        }
      }

      var newProducts = newCartProducts.map(function(product) {
        product.quantity = 1;

        return product;
      });

      state.products.push(...newProducts);
    },

    increaseCartItem(state, payload) {
      var item = state.products.filter((product) => product.id === payload)[0];
      Vue.set(item, "quantity", item.quantity + 1);
    },

    decreaseCartItem(state, payload) {
      var item = state.products.filter((product) => product.id === payload)[0];
      Vue.set(item, "quantity", item.quantity - 1);
    },

    deleteCartProducts(state, payload) {
      function isProduct(cartProduct) {
        return cartProduct.id === this.id;
      }

      payload.filter((selectedProduct) => {
        const index = state.products.findIndex(isProduct, selectedProduct);
        state.products.splice(index, 1);
      });
    },

    clearCartProducts(state) {
      state.products = [];
    },
  },

  actions: {
    updateCartItemPrice({ commit }, payload) {
      return new Promise((resolve, reject) => {
        try {
          commit("changeCartItemPrice", payload);
          resolve();
        } catch (error) {
          reject(error);
        }
      });
    },
  },
};
